import { type ReactNode } from 'react';
import { RequiredVideoPlayer } from '@/components/ui';

export function VerificationVideo(): ReactNode {
  return (
    <div className="space-y-sm lg:self-center">
      <p className="text-xs text-text-tertiary">La prueba final</p>
      <RequiredVideoPlayer />
    </div>
  );
}
